import React, { useEffect, useState } from 'react';
import { api, HERITAGE_ASSETS } from '@/lib/api';
import { Panel } from '@/components/Panel';
import { Lock } from 'lucide-react';

export default function Vault() {
  const [products, setProducts] = useState([]);
  useEffect(() => { (async () => { const { data } = await api.get('/founders/vault'); setProducts(data.products || []); })(); }, []);
  return (
    <div className="space-y-6">
      <Panel className="p-8">
        <div className="h-eyebrow flex items-center gap-2"><Lock size={14} /> Founder Vault</div>
        <div className="h-display text-4xl mt-1" style={{ color: 'var(--heritage-plum)' }}>Exclusive drops</div>
        <div className="text-sm opacity-80 mt-1" style={{ color: 'var(--heritage-plum)' }}>Founder-only products, early access, and members pricing.</div>
      </Panel>

      <div className="grid md:grid-cols-3 gap-6">
        {products.map(p => (
          <Panel key={p.id} className="p-3 overflow-hidden">
            <img src={p.image_url || p.image_base64 || HERITAGE_ASSETS.editorial} alt={p.name} className="w-full h-64 object-cover rounded-lg" />
            <div className="p-4">
              <div className="h-eyebrow">Founder Exclusive</div>
              <div className="h-serif text-xl mt-1" style={{ color: 'var(--heritage-plum)' }}>{p.name}</div>
              <div className="text-sm opacity-80 mt-1" style={{ color: 'var(--heritage-plum)' }}>{p.description}</div>
              <div className="flex items-center justify-between mt-3">
                <div className="h-serif text-lg" style={{ color: 'var(--heritage-plum)' }}>${p.price} NZD</div>
                <button className="h-btn text-xs" disabled title="Vault opens after founder deliveries">Coming Soon</button>
              </div>
            </div>
          </Panel>
        ))}
        {products.length === 0 && (
          <div className="text-sm opacity-70" style={{ color: 'var(--heritage-plum)' }}>Vault opens shortly after founder deliveries.</div>
        )}
      </div>
    </div>
  );
}
